<template>
    <v-chip class="mr-2 d-block rounded-0 bg-grey-lighten-4 pa-0" size="small" variant="flat">
        <svg-icon :icon="location" alt="location" />
        <span data-id="orderHistoryItemZoneName" class="ml-4 secondary-text-color">{{ zoneName }}</span>
    </v-chip>
</template>

<script setup lang="ts">
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import location from '@/assets/location.svg';

interface IOrderHistoryCardZone {
    zoneName: string;
}

defineProps<IOrderHistoryCardZone>();
</script>
